import { styled as o, css as t } from "styled-components";
import { Theme as r } from "../../../../styles/themes/index.js";
import { SmallLight as e } from "../../../../styles/typography/index.js";
import { MediaQuery as i } from "../../../../styles/variables.js";
const p = o.div`
  display: flex;
  align-items: center;
  padding: 8px 24px;
  gap: 24px;
  background: rgb(${r.colors.Juliet});
  border: 1px solid rgb(${r.colors.Hotel});
  border-radius: 32px;
`, m = o.button`
  background: none;
  display: flex;
  flex-direction: column;
  align-items: center;

  i {
    font-size: 16px;
  }

  span {
    ${e}
    margin-top: 2px;
  }
`, d = t`
  right: 68%;
  transform: translateX(68%);

  @media ${i.SCREEN_MD_UP} {
    right: 58%;
    transform: translateX(58%);
  }
`;
export {
  p as Container,
  m as ReactButton,
  d as reactionsPopoverContainerStyle
};
